import * as Sentry from "@sentry/react"
import { useNavigate } from "@tanstack/react-router"
import { Button } from "design-system/atoms/Button"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "design-system/atoms/Dialog"
import { useDeleteOutlookIntegrationMutation } from "modules/settings/hooks/outlook/useDeleteOutlookIntegrationMutation"
import { useOutlookIntegrationsQuery } from "modules/settings/hooks/outlook/useOutlookIntegrationsQuery"
import { useState } from "react"
import { Trans, useTranslation } from "react-i18next"
import { Route as DeleteOutlookIntegrationRoute } from "routes/_base/_auth/settings/channels/outlook/deleteIntegration.$id"

export const DeleteOutlookIntegration = () => {
  const { t } = useTranslation()
  const { id } = DeleteOutlookIntegrationRoute.useParams()
  const navigate = useNavigate()
  const { mutateAsync } = useDeleteOutlookIntegrationMutation()
  const [isLoading, setIsLoading] = useState(false)
  const { data } = useOutlookIntegrationsQuery()
  const integrationInfo = data?.find((e) => e.id === id)

  const onCancel = () => {
    navigate({ to: "/settings/channels/outlook" })
  }

  const onDelete = async () => {
    setIsLoading(true)

    await mutateAsync({ id })
      .then(() => {
        onOpenChange()
      })
      .catch((error) => {
        Sentry.captureException(error)
        setIsLoading(false)
      })
  }

  const onOpenChange = (isOpen: boolean = false) => {
    if (!isOpen) {
      navigate({ to: "/settings/channels/outlook" })
    }
  }

  return (
    <Dialog open onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t("settings.integrations.outlook.deleteIntegration.title")}</DialogTitle>
          <DialogDescription>
            <Trans
              i18nKey={"settings.integrations.outlook.deleteIntegration.description"}
              values={{ email: integrationInfo?.email }}
              components={{ b: <b /> }}
            />
          </DialogDescription>
        </DialogHeader>
        <div className="mt-2">
          <DialogFooter>
            <Button variant={"secondary"} onClick={onCancel} disabled={isLoading}>
              {t("settings.integrations.outlook.deleteIntegration.actions.cancel")}
            </Button>
            <Button onClick={onDelete} disabled={isLoading}>
              {t("settings.integrations.outlook.deleteIntegration.actions.delete")}
            </Button>
          </DialogFooter>
        </div>
      </DialogContent>
    </Dialog>
  )
}
